import OptionItem from '@components/atoms/option-item/option-item';
import TextSwatch from '@components/atoms/text-swatch/text-swatch';
import ColorSwatch from '@components/catalog/color-swatch/color-swatch';
import colorSwatchColorMap from '@maps/components/color-swatch-color-map';
import React from 'react';
import { ElasticSearchFacet } from '@interfaces/api/responses/elasticSearch';
import Switch from '@components/catalog/switch/switch';
import { ElasticSearchFacetsFields } from '@interfaces/models/elasticSearch';

const components = {
  'text-swatch': TextSwatch,
  'color-swatch': ColorSwatch,
  item: OptionItem,
  switch: Switch,
};

export type GenericItemProps = {
  filterGroup: ElasticSearchFacetsFields;
  id: string;
  label: string;
  count: number;
  variant: keyof typeof components;
  facet: ElasticSearchFacet;
  onChange: (input: Event | boolean) => void;
  checked: boolean;
  disabled?: boolean;
} & React.HTMLProps<HTMLDivElement>;

// From Generic to Specific Item mapping based on the type/variant of the facet received
const GenericItem: React.FC<GenericItemProps> = (props): React.JSX.Element => {
  const { id, label, count, variant = 'item', onChange, checked, disabled, filterGroup } = props;

  const swatchColor = filterGroup === 'color' ? colorSwatchColorMap(id) : undefined;
  const htmlId = `${variant}-${label}-${id}-${count}`;
  const dataCySelector = `${filterGroup}-${id}-filter`;

  const args = {
    htmlId,
    checked,
    label,
    onChange,
    swatchColor,
    disabled,
    ['data-cy']: dataCySelector,
    ...(['text-swatch', 'item'].includes(variant) ? { useFilterRedesignUi: true } : {}),
  };

  const SpecificItem = components[variant];

  return <SpecificItem {...args} />;
};

export default GenericItem;
